import { jsx as _jsx } from "react/jsx-runtime";
const SmallCircle = ({ className }) => {
    return (_jsx("svg", { width: "136", height: "131", viewBox: "0 0 136 131", fill: "none", className: className, children: _jsx("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M47.3558 4.29573C9.89201 16.879 -8.97052 50.2635 6.32302 86.6429C21.6166 123.022 53.0516 137.237 88.6702 127.676C124.289 118.114 146.074 82.1328 129.703 45.3285C113.332 8.52423 84.8195 -8.28749 47.3558 4.29573Z", fill: "#A347FF" }) }));
};
export default SmallCircle;
